export default __webpack_public_path__ + "static/appleFooter-66a3ad4820280df74bf44cb98f2357c5.svg";